export default __webpack_public_path__ + "static/media/Product-versions.8634afd6.svg";